<script setup lang="ts">
import SlideToggle from "@/components/ui/SlideToggle.vue";

const isTestDatasource = defineModel<boolean>("isTestDatasource");
</script>

<template>
  <div class="datasources">
    <div class="datasource" :class="{ selected: !isTestDatasource }">
      <i class="icon icon-receipt" /> Train
    </div>
    <SlideToggle v-model:is-toggled="isTestDatasource" />
    <div class="datasource" :class="{ selected: isTestDatasource }">
      <i class="icon icon-signal" /> Test
    </div>
  </div>
</template>

<style scoped>
.datasources {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: right;
  gap: var(--spacing-6);

  .datasource {
    color: var(--color-text-secondary);
    transition: color var(--animation-duration) var(--animation-easing);

    &.selected {
      color: var(--color-text-branding);
    }
  }
}
</style>
